(() => {
  const fallback = {
    separator: ' + ',
    empty: 'No finishing',
    note: 'Select any combination. The price updates with your choices.',
    unavailable: 'This combination is unavailable. Choose another set of options.',
  };

  const charges = (radios, separator, empty) => {
    const map = {};
    radios.forEach((radio) => {
      if (radio.value === empty || radio.value.includes(separator)) return;
      const delta = document.querySelector(`label[for="${radio.id}"] .kp-finish-delta`);
      if (delta) map[radio.value] = delta.textContent.trim();
    });
    return map;
  };

  const mount = (fieldset) => {
    if (fieldset.dataset.kpMultiReady) return;
    const host = fieldset.querySelector('[data-kp-finishing-multi]');
    const data = fieldset.dataset;
    const separator = data.kpFinishingSeparator || fallback.separator;
    const empty = data.kpFinishingEmpty || fallback.empty;
    const radios = [...fieldset.querySelectorAll('input[type="radio"]')];
    if (!host || !radios.some((radio) => radio.value.includes(separator))) return;
    fieldset.dataset.kpMultiReady = '1';

    const map = charges(radios, separator, empty);
    const names = [...new Set(
      radios.flatMap((radio) => (radio.value === empty ? [] : radio.value.split(separator))),
    )];
    const boxes = names.map((name) => {
      const label = document.createElement('label');
      label.className = 'kp-finishing-multi__item';
      const checkbox = document.createElement('input');
      checkbox.type = 'checkbox';
      checkbox.value = name;
      const text = document.createElement('span');
      text.textContent = map[name] ? `${name} · ${map[name]}` : name;
      label.append(checkbox, text);
      host.append(label);
      return checkbox;
    });

    const status = document.createElement('p');
    status.className = 'kp-finishing-multi__status';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    host.append(status);

    const note = document.createElement('p');
    note.className = 'kp-finishing-multi__note';
    note.textContent = data.kpFinishingNote || fallback.note;
    host.append(note);

    const usable = (radio) => radio && !radio.disabled && !radio.classList.contains('disabled');
    const syncFromVariant = () => {
      const chosen = radios.find((radio) => radio.checked)?.value || empty;
      const parts = chosen === empty ? [] : chosen.split(separator);
      boxes.forEach((box) => {
        box.checked = parts.includes(box.value);
        box.parentElement.classList.toggle('is-selected', box.checked);
      });
    };
    const selectVariant = () => {
      const chosen = boxes.filter((box) => box.checked).map((box) => box.value);
      // The variant values are always written in the canonical order of the
      // option values, not the order the shopper ticked the boxes. Build the
      // label in that order so the lookup finds the variant.
      const value = chosen.length ? names.filter((name) => chosen.includes(name)).join(separator) : empty;
      const radio = radios.find((item) => item.value === value);
      if (!usable(radio)) {
        status.textContent = data.kpFinishingUnavailable || fallback.unavailable;
        syncFromVariant();
        return;
      }
      status.textContent = '';
      radio.click();
      syncFromVariant();
    };
    boxes.forEach((box) => box.addEventListener('change', (event) => {
      // Only the matching Shopify radio should trigger a variant update.
      // Letting this checkbox event bubble sends an extra request with no
      // option-value ID and can replace the picker with an empty one.
      event.stopPropagation();
      selectVariant();
    }));
    radios.forEach((radio) => radio.addEventListener('change', syncFromVariant));
    syncFromVariant();
  };

  const scan = () => document.querySelectorAll('[data-kp-finishing-combinations]').forEach(mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('kp:variant-selects-updated', scan);
})();
